import { getSafeExternalUrl } from './safe-external-url.js';
import { isUrlBlocked } from './domain-blocklist-cache.js';

/**
 * Open a validated external URL from a user gesture (widget parent handler).
 * @param {string} rawUrl
 * @returns {boolean} true if a tab was opened
 */
export function openExternalUrl(rawUrl) {
  const url = getSafeExternalUrl(rawUrl);
  if (!url) {
    window.logger?.warn('Blocked unsafe external URL:', rawUrl);
    return false;
  }
  if (isUrlBlocked(url)) {
    window.logger?.warn('Blocked external URL on domain blocklist:', url);
    return false;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}
